var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgApFireAlarmIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "b"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 36,
    height: 36
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "a",
    clipPath: "url(#b)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-1778.57 -8297)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M64.892,12.441a13.379,13.379,0,0,1,3.458,2.47,13.151,13.151,0,0,1,2.589,3.549.564.564,0,1,0,1.011-.5,14.282,14.282,0,0,0-2.808-3.851,14.524,14.524,0,0,0-3.748-2.676.564.564,0,0,0-.5,1.011Z",
    transform: "translate(1736.841 8289.608)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.561,14.1a14.277,14.277,0,0,0-2.81,3.853.563.563,0,0,0,.254.757.575.575,0,0,0,.251.059.563.563,0,0,0,.505-.313,13.188,13.188,0,0,1,2.592-3.551,13.388,13.388,0,0,1,3.455-2.467.564.564,0,0,0-.5-1.011A14.508,14.508,0,0,0,15.561,14.1Z",
    transform: "translate(1769.979 8289.608)"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(1779.57 8298)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M42.492,44.876a3.633,3.633,0,1,0-3.633-3.633A3.637,3.637,0,0,0,42.492,44.876Zm0-6.135a2.5,2.5,0,1,1-2.5,2.5A2.507,2.507,0,0,1,42.492,38.741Z",
    transform: "translate(-26.303 -25.148)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.053,47.5a.563.563,0,0,0,.548-.58c0-.08,0-.161,0-.241a.565.565,0,1,0-1.129,0c0,.092,0,.183,0,.274a.564.564,0,0,0,.565.548h.017Z",
    transform: "translate(-16.474 -30.577)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.922,59.251a.558.558,0,0,0,.2.037.565.565,0,0,0,.2-1.093A8.09,8.09,0,0,1,25.4,52.762a.564.564,0,1,0-1.09.294,9.221,9.221,0,0,0,5.609,6.194Z",
    transform: "translate(-17 -34.559)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.785,4.208a16.392,16.392,0,0,1,8.435,8.567.565.565,0,0,0,1.039-.443,17.517,17.517,0,0,0-9.014-9.155.564.564,0,0,0-.46,1.03Z",
    transform: "translate(-43.925 -3.127)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.186,24.966a2.435,2.435,0,0,0-.758,4.751,13.843,13.843,0,0,1-5.711,9.092V35.545a11.463,11.463,0,1,0-16.127,0v7.707a1.941,1.941,0,0,0,1.941,1.937H34.774a1.942,1.942,0,0,0,1.941-1.937V40.164a14.977,14.977,0,0,0,6.839-10.352,2.437,2.437,0,0,0-.37-4.847ZM18.32,27.408A10.334,10.334,0,1,1,28.654,37.742,10.345,10.345,0,0,1,18.32,27.408ZM34.776,44.06H22.532a.811.811,0,0,1-.812-.807V36.514a11.38,11.38,0,0,0,13.868,0v6.737a.81.81,0,0,1-.812.807Zm8.41-15.339A1.313,1.313,0,1,1,44.5,27.408,1.314,1.314,0,0,1,43.186,28.72Z",
    transform: "translate(-12.465 -11.312)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.456,13.07a.556.556,0,0,0,.222.045.564.564,0,0,0,.519-.343,16.4,16.4,0,0,1,8.435-8.567.564.564,0,0,0-.46-1.03,17.517,17.517,0,0,0-9.014,9.154.565.565,0,0,0,.3.741Z",
    transform: "translate(-4.113 -3.126)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.4,85.742H42.447a.565.565,0,1,0,0,1.129H46.4a.565.565,0,1,0,0-1.129Z",
    transform: "translate(-28.234 -55.888)"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgApFireAlarmIcon);
export default __webpack_public_path__ + "static/media/ap-fire-alarm-icon.d7bce76dc15cf08932c857b7be605dca.svg";
export { ForwardRef as ReactComponent };